import { type FC } from "react";

import { css } from "@emotion/css";
import { Spinner } from "@snapchat/snap-design-system";

import { type LensMetadata } from "../../gql-generated/insights-types";
import { ChartCard } from "../../lens-insights/components/shared";

import { TopLensCard } from "./TopLensCard";
import { TopLenses } from "./messages.generated";
import { TopLensesSection } from "./shared";

interface TopLensesContainerProps {
    loading: boolean;
    lensMetadata: LensMetadata[];
}

const temp = css`
    width: 100%;
`;

export const TopLensesContainer: FC<TopLensesContainerProps> = ({ loading, lensMetadata }) => {
    return (
        <ChartCard title={<TopLenses />} className={temp}>
            {loading ? (
                <Spinner />
            ) : (
                <TopLensesSection>
                    {lensMetadata.map((lens) => {
                        return (
                            <TopLensCard
                                key={lens.id}
                                lens={{
                                    id: lens.id ?? "",
                                    preview: lens.lensPreviewUrl ?? "",
                                    icon: lens.imageLink ?? "",
                                    name: lens.publicName ?? "",
                                    value: "",
                                }}
                            />
                        );
                    })}
                </TopLensesSection>
            )}
        </ChartCard>
    );
};
